import { useWindowWidth } from 'src/hooks/useWindowWidth';
import { ParsedProductPreview } from 'src/types/marketplace';
import { CarouselBase } from 'src/uikit/Carousels/CarouselBase';

import { MarketplaceCard } from '../MarketplaceCard';
import s from './MarketplaceCarousel.module.scss';

export interface MarketplaceCarouselProps {
  slides: ParsedProductPreview[];
}

export function MarketplaceCarousel({ slides }: MarketplaceCarouselProps) {
  const {
    windowWidth,
    breakpoints: { CAROUSEL_NAVIGATION, MD, SM },
  } = useWindowWidth();

  const getSliders = () => {
    if (!windowWidth) {
      return 1;
    }

    if (windowWidth <= SM) {
      return 1;
    }

    return windowWidth > MD ? 3 : 2;
  };

  return (
    <div className={s.carouselWrapper}>
      <CarouselBase
        autoPlay
        slidesCount={slides.length}
        withNavigation={
          slides.length > 3 &&
          !!windowWidth &&
          windowWidth > CAROUSEL_NAVIGATION
        }
        alwaysShowPaginationDots
        loop
        carouselClassName={s.carousel}
        navigationClassName={s.navigation}
        slideClassName={s.slide}
        slidesPerView={getSliders()}
        slidesSpacing={windowWidth && windowWidth <= MD ? 16 : 24}
      >
        {slides.map((product) => (
          <MarketplaceCard key={product.slug} {...product} />
        ))}
      </CarouselBase>
    </div>
  );
}
